(function () {
  const SELECTOR =
    '.accordion > details, details.faq__item, details.footer-block__details, details.footer-policies';
  const DURATION = 340;
  const EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';
  const running = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function summaryHeight(details) {
    const summary = details.querySelector(':scope > summary');
    return summary ? summary.getBoundingClientRect().height : 0;
  }

  function settle(details) {
    const current = running.get(details);
    if (current) {
      current.cancel();
      running.delete(details);
    }
    details.style.removeProperty('height');
    details.style.removeProperty('overflow');
  }

  function run(details, from, to, onFinish) {
    settle(details);
    details.style.overflow = 'hidden';
    details.style.height = from + 'px';

    const animation = details.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: DURATION, easing: EASING }
    );
    running.set(details, animation);

    const done = () => {
      if (running.get(details) !== animation) return;
      running.delete(details);
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      if (onFinish) onFinish();
    };

    animation.addEventListener('finish', done, { once: true });
    animation.addEventListener(
      'cancel',
      () => {
        if (running.get(details) === animation) running.delete(details);
      },
      { once: true }
    );
  }

  function expand(details) {
    const from = running.has(details)
      ? details.getBoundingClientRect().height
      : summaryHeight(details);
    details.open = true;
    run(details, from, details.scrollHeight);
  }

  function collapse(details, onFinish) {
    const from = details.getBoundingClientRect().height;
    run(details, from, summaryHeight(details), () => {
      details.open = false;
      if (onFinish) onFinish();
    });
  }

  function collapseGroupSiblings(details) {
    const group = details.getAttribute('name');
    if (!group) return;

    document.querySelectorAll('details[name="' + CSS.escape(group) + '"][open]').forEach((sibling) => {
      if (sibling === details) return;
      sibling.removeAttribute('name');
      collapse(sibling, () => sibling.setAttribute('name', group));
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      const summary = event.target.closest('summary');
      if (!summary) return;

      const details = summary.parentElement;
      if (!details || !details.matches(SELECTOR)) return;
      if (prefersReducedMotion()) return;

      event.preventDefault();

      if (details.open) {
        collapse(details);
      } else {
        collapseGroupSiblings(details);
        expand(details);
      }
    },
    false
  );
})();
